<template>
  <div class="description-list-table" style="max-width: 1280px;">
    <div v-if="title" class="dl-title">{{ title }}</div>
    <Row :gutter="0"> <!-- 注意：gutter设为0，避免边框间隙 -->
      <Col 
        v-for="(item, index) in data" 
        :key="index"
        :span="getSpan(item.span)"
        class="dl-cell"
      >
        <div class="dl-term">{{ item.label }}</div>
        <div class="dl-value">
          <slot :name="item.key" :record="item">
            {{ (item.value === null || item.value === undefined) ? '-' : item.value }}
          </slot>
        </div>
      </Col>
    </Row>
  </div>
</template>


<script>
export default {
  name: 'DescriptionList',
  props: {
    // 列表标题
    title: {
      type: String,
      default: ''
    },
    // 数据源数组: [{ label: this.$tt('姓名'), key: 'name', value: '张三', span: 12 }]
    data: {
      type: Array,
      default: () => []
    },
    // 栅格间隔
    gutter: {
      type: Number,
      default: 24
    },
    // 默认每列占的份数 (24栅格系统)
    // 例如 col=2 表示一行两列，每列 span=12
    col: {
      type: Number,
      default: 2
    }
  },
  methods: {
    getSpan(customSpan) {
      if (customSpan) return customSpan;
      // 根据 col 属性计算默认 span
      // col=1 -> span=24, col=2 -> span=12, col=3 -> span=8, col=4 -> span=6
      return 24 / this.col;
    }
  }
};
</script>

<style scoped>
.description-list-table {
  border: 1px solid #e8eaec; /* 外边框 */
  border-radius: 4px;
  overflow: hidden; /* 防止圆角溢出 */
}

.dl-title {
  padding: 10px 16px;
  background-color: #f8f8f9;
  border-bottom: 1px solid #e8eaec;
  font-weight: bold;
}

.dl-item {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column; /* 垂直布局：Label在上，Value在下 */
  border-bottom: 1px solid #e8eaec;
}

/* 如果希望水平布局（Label在左，Value在右），可修改此处或使用 modifier */
.dl-item.horizontal {
  flex-direction: row;
  align-items: center;
}

.dl-term {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 4px;
  line-height: 1.5;
}

.required {
  color: #ed4014;
  margin-right: 4px;
}

.dl-value {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5;
  word-break: break-all;
}


.dl-cell {
  /* 关键：使用 border-right 和 border-bottom 模拟网格 */
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  box-sizing: border-box;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 50px;
  border-bottom: 1px solid #e8eaec;
}

/* 去除每一行最后一个元素的右边框，避免双重边框或右侧多余线条 */
/* 注意：这需要配合具体的 span 计算逻辑，或者简单起见，让所有单元格都有右边框，父容器 overflow:hidden 截断 */
/* 更简单的做法：只给非最后一列加右边框，但动态计算较复杂。
   通用做法：所有格子都有右和下边框，父级设 overflow:hidden 且宽度固定，
   或者使用 margin-left: -1px 等技巧重叠边框。
   
   这里采用最稳健的“重叠边框”写法：
*/
.dl-cell {
  margin-left: 0px; 
  margin-top: 0px;
  position: relative;
  z-index: 1;
}
</style>
